import { render, staticRenderFns } from "./AIClassificationIcon.vue?vue&type=template&id=1f2556f5&scoped=true"
import script from "./AIClassificationIcon.vue?vue&type=script&lang=js"
export * from "./AIClassificationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2556f5",
  null
  
)

export default component.exports